/* pf build 2026-07-10b */
/* PAN-FILIO · Home — barra de envío (carrito real de Shopify) + add-to-cart.
   Se apoya en el carrito nativo de Shopify (/cart.js, /cart/add.js).
   Las ilustraciones de marca ya vienen inline desde Liquid (no fetch). */
(function () {
  'use strict';
  if (window.__pfHomeInit) return;         // correr una sola vez aunque se incluya en varias secciones
  window.__pfHomeInit = true;
  var THRESHOLD = (window.PF_FREESHIP && parseInt(window.PF_FREESHIP, 10)) || 799;

  function pesos(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }

  function updateShip(totalCents) {
    var total = (totalCents || 0) / 100;
    var remaining = Math.max(0, THRESHOLD - total);
    var pct = Math.min(100, THRESHOLD ? (total / THRESHOLD) * 100 : 0);
    document.querySelectorAll('.pf-store .ship-bar').forEach(function (bar) {
      var txt = bar.querySelector('.ship-txt');
      var fill = bar.querySelector('.ship-fill');
      if (fill) fill.style.width = pct + '%';
      if (remaining > 0) {
        bar.classList.remove('is-free');
        if (txt) txt.innerHTML = 'Te faltan <b>' + pesos(remaining) + '</b> para envío gratis';
      } else {
        bar.classList.add('is-free');
        if (txt) txt.innerHTML = '<b>¡Felicidades!</b> Tienes envío gratis en este pedido';
      }
    });
  }

  function updateCount(n) {
    document.querySelectorAll('.pf-cart-count').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.pf-store .head__cart').forEach(function (el) { el.classList.toggle('has', n > 0); });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateShip(c.total_price); updateCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- SIDE CART (siempre drawer, nunca página) ---------- */
  function cdEl() { return document.getElementById('pfcd'); }
  function cdOpen() {
    var d = cdEl(), s = document.getElementById('pfcdScrim');
    if (!d) return;
    d.classList.add('open'); if (s) s.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function cdClose() {
    var d = cdEl(), s = document.getElementById('pfcdScrim');
    if (!d) return;
    d.classList.remove('open'); if (s) s.classList.remove('open');
    document.body.style.overflow = '';
  }
  function cdLine(item) {
    var line = document.createElement('div');
    line.className = 'pfcd__line';
    line.setAttribute('data-pfcd-key', item.key);
    var a = document.createElement('a'); a.className = 'pfcd__img'; a.href = item.url;
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      img.alt = item.product_title; img.width = 160; img.height = 160; img.loading = 'lazy';
      a.appendChild(img);
    }
    var info = document.createElement('div'); info.className = 'pfcd__info';
    var nm = document.createElement('a'); nm.className = 'pfcd__name'; nm.href = item.url; nm.textContent = item.product_title;
    info.appendChild(nm);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      var vt = document.createElement('span'); vt.className = 'pfcd__variant'; vt.textContent = item.variant_title;
      info.appendChild(vt);
    }
    var row = document.createElement('div'); row.className = 'pfcd__row';
    var qty = document.createElement('div'); qty.className = 'pfcd__qty';
    var bm = document.createElement('button'); bm.type = 'button'; bm.setAttribute('data-pfcd-qty', '-1'); bm.setAttribute('aria-label', 'Menos'); bm.textContent = '−';
    var qn = document.createElement('span'); qn.textContent = item.quantity;
    var bp = document.createElement('button'); bp.type = 'button'; bp.setAttribute('data-pfcd-qty', '1'); bp.setAttribute('aria-label', 'Más'); bp.textContent = '+';
    qty.appendChild(bm); qty.appendChild(qn); qty.appendChild(bp);
    var rm = document.createElement('button'); rm.className = 'pfcd__rm'; rm.type = 'button'; rm.setAttribute('data-pfcd-rm', ''); rm.textContent = 'Quitar';
    var lt = document.createElement('b'); lt.className = 'pfcd__ltotal'; lt.textContent = pesos(item.final_line_price / 100);
    row.appendChild(qty); row.appendChild(rm); row.appendChild(lt);
    info.appendChild(row);
    line.appendChild(a); line.appendChild(info);
    return line;
  }
  function cdRender(cart) {
    var d = cdEl();
    if (!d) return;
    var thr = parseInt(d.getAttribute('data-pf-threshold'), 10) || THRESHOLD;
    var items = d.querySelector('[data-pfcd-items]');
    if (items) {
      items.textContent = '';
      cart.items.forEach(function (it) { items.appendChild(cdLine(it)); });
    }
    var count = d.querySelector('[data-pfcd-count]');
    if (count) count.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    var total = d.querySelector('[data-pfcd-total]');
    if (total) total.textContent = pesos(cart.total_price / 100);
    var remaining = Math.max(0, thr - cart.total_price / 100);
    var fill = d.querySelector('[data-pfcd-fill]');
    if (fill) fill.style.width = Math.min(100, (cart.total_price / 100 / thr) * 100) + '%';
    var goal = d.querySelector('[data-pfcd-goal]');
    if (goal) goal.classList.toggle('reached', remaining <= 0);
    var msg = d.querySelector('[data-pfcd-msg]');
    if (msg) {
      msg.textContent = '';
      if (remaining > 0) {
        msg.appendChild(document.createTextNode('Te faltan '));
        var b = document.createElement('b'); b.textContent = pesos(remaining);
        msg.appendChild(b);
        msg.appendChild(document.createTextNode(' para envío gratis'));
      } else {
        var b2 = document.createElement('b'); b2.textContent = '¡Tienes envío gratis!';
        msg.appendChild(b2);
        msg.appendChild(document.createTextNode(' 🎉'));
      }
    }
    var ptsEl = d.querySelector('[data-pfcd-points]');
    if (ptsEl) {
      var rate = parseFloat(d.querySelector('[data-pfcd-ptsrate]') && d.querySelector('[data-pfcd-ptsrate]').getAttribute('data-pfcd-ptsrate')) || 1;
      ptsEl.textContent = Math.floor((cart.total_price / 100) * rate);
    }
    var minEl = d.querySelector('[data-pfcd-minorder]');
    if (minEl) {
      var minThr = (parseInt(minEl.getAttribute('data-min'), 10) || 300) * 100;
      var below = cart.item_count > 0 && cart.total_price < minThr;
      minEl.hidden = !below;
      if (below) {
        var mr = minEl.querySelector('[data-pfcd-minremain]');
        if (mr) mr.textContent = pesos((minThr - cart.total_price) / 100);
      }
    }
    var empty = d.querySelector('[data-pfcd-empty]');
    var foot = d.querySelector('[data-pfcd-foot]');
    if (empty) empty.hidden = cart.item_count > 0;
    if (foot) foot.hidden = cart.item_count === 0;
  }
  function cdSync(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cdRender(c);
        updateShip(c.total_price);
        updateCount(c.item_count);
        if (open) cdOpen();
      })
      .catch(function () {});
  }
  function cdChange(key, qty) {
    var d = cdEl();
    var line = d && d.querySelector('[data-pfcd-key="' + key + '"]');
    if (line) line.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(function (c) { cdRender(c); updateShip(c.total_price); updateCount(c.item_count); })
      .catch(function () { cdSync(false); });
  }
  // abrir desde el icono del carrito (en captura: el tema base también escucha)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pfcd-open]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      cdSync(true);
      return;
    }
    if (e.target.closest('[data-pfcd-close]') || e.target.closest('#pfcdScrim')) {
      e.preventDefault(); cdClose();
      return;
    }
    var qb = e.target.closest('[data-pfcd-qty]');
    if (qb) {
      e.preventDefault(); e.stopPropagation();
      var line = qb.closest('[data-pfcd-key]');
      var cur = parseInt(line.querySelector('.pfcd__qty span').textContent, 10) || 1;
      cdChange(line.getAttribute('data-pfcd-key'), Math.max(0, cur + parseInt(qb.getAttribute('data-pfcd-qty'), 10)));
      return;
    }
    var rm = e.target.closest('[data-pfcd-rm]');
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      var line2 = rm.closest('[data-pfcd-key]');
      cdChange(line2.getAttribute('data-pfcd-key'), 0);
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cdClose(); });


  /* ---------- HERO carrusel (delegación global: inmune al orden de carga) ---------- */
  function heroTrack() { return document.querySelector('[data-pf-hero-track]'); }
  function heroIdx() { var t = heroTrack(); return t ? Math.round(t.scrollLeft / (t.clientWidth || 1)) : 0; }
  function heroGoTo(i) {
    var t = heroTrack(); if (!t) return;
    var n = t.querySelectorAll('.hero2__slide').length;
    var k = ((i % n) + n) % n;
    t.scrollTo({ left: k * t.clientWidth, behavior: 'smooth' });
  }
  function heroPaint() {
    var i = heroIdx();
    document.querySelectorAll('[data-pf-hero-dot]').forEach(function (d) {
      d.classList.toggle('on', parseInt(d.getAttribute('data-pf-hero-dot'), 10) === i);
    });
  }
  var heroTimer = null;
  function heroStop() { if (heroTimer) { clearInterval(heroTimer); heroTimer = null; } }
  function heroStart() {
    var hero = document.querySelector('[data-pf-hero]');
    if (!hero) return;
    var secs = parseInt(hero.getAttribute('data-pf-autoplay'), 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!secs || reduce) return;
    heroStop();
    heroTimer = setInterval(function () { heroGoTo(heroIdx() + 1); }, secs * 1000);
  }
  // clicks en flechas y dots — en captura, por si el tema base los intercepta
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-pf-hero-go]');
    if (go) { e.preventDefault(); e.stopPropagation(); heroStop(); heroGoTo(heroIdx() + parseInt(go.getAttribute('data-pf-hero-go'), 10)); return; }
    var dot = e.target.closest('[data-pf-hero-dot]');
    if (dot) { e.preventDefault(); e.stopPropagation(); heroStop(); heroGoTo(parseInt(dot.getAttribute('data-pf-hero-dot'), 10)); }
  }, true);
  var heroRaf;
  document.addEventListener('scroll', function (e) {
    if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-pf-hero-track')) return;
    cancelAnimationFrame(heroRaf); heroRaf = requestAnimationFrame(heroPaint);
  }, true);

  function setupHero() {
    var hero = document.querySelector('[data-pf-hero]');
    if (!hero || hero.querySelectorAll('.hero2__slide').length < 2) return;
    heroPaint();
    heroStart();
    hero.addEventListener('mouseenter', heroStop);
    hero.addEventListener('mouseleave', heroStart);
    hero.addEventListener('touchstart', heroStop, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? heroStop() : heroStart(); });
  }

  /* ---------- Drawer + búsqueda (header) ---------- */
  function setupHeader() {
    var drawer = document.getElementById('pfDrawer');
    var scrim = document.getElementById('pfScrim');
    if (drawer && scrim) {
      var open = function () { drawer.classList.add('open'); scrim.classList.add('open'); document.body.style.overflow = 'hidden'; };
      var close = function () { drawer.classList.remove('open'); scrim.classList.remove('open'); document.body.style.overflow = ''; };
      document.querySelectorAll('[data-pf-open-menu]').forEach(function (b) { b.addEventListener('click', open); });
      document.querySelectorAll('[data-pf-close-menu]').forEach(function (b) { b.addEventListener('click', close); });
      scrim.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    var sbtn = document.querySelector('[data-pf-search]');
    var swrap = document.getElementById('pfSearchWrap');
    if (sbtn && swrap) {
      sbtn.addEventListener('click', function () {
        var on = swrap.classList.toggle('open');
        sbtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) { var inp = swrap.querySelector('input'); if (inp) setTimeout(function () { inp.focus(); }, 60); }
      });
    }
  }

  function flash(btn) {
    if (!btn) return;
    btn.classList.add('added');
    setTimeout(function () { btn.classList.remove('added'); }, 900);
  }

  /* Add-to-cart AJAX. En fase de CAPTURA y con stopPropagation para que
     el JS del tema base (cart drawer de Minimog) no intercepte el submit. */
  function doAdd(form) {
    var btn = form.querySelector('button');
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        flash(btn);
        cdSync(true);   // re-render + abrir el side cart
        try { if (window.BidoThemeEvents && window.BidoThemeEvents.emit) window.BidoThemeEvents.emit('cart-update'); } catch (err) {}
      })
      .catch(function () {
        // último recurso: navegar al carrito con el producto vía GET permalink
        var id = form.querySelector('[name=id]');
        if (id) window.location.href = '/cart/add?id=' + id.value + '&quantity=1';
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pf-add-form button[data-pf-add], .pf-add-form button[type="submit"]:not([data-pf-qty])');
    if (!btn || btn.hasAttribute('data-pf-qty') || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    doAdd(btn.closest('.pf-add-form'));
  }, true);

  /* Pastillas de variante y cantidad: también en CAPTURA (el cart.js del
     tema base se traga los clicks de botones dentro de forms de carrito). */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.pdp__pill');
    if (pill) {
      e.preventDefault();
      e.stopPropagation();
      var group = pill.closest('[data-pf-option-group]');
      if (group) {
        group.querySelectorAll('.pdp__pill').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
        pill.classList.add('on');
        pill.setAttribute('aria-pressed', 'true');
      }
      if (typeof window.__pfVariantRefresh === 'function') window.__pfVariantRefresh();
      return;
    }
    var qb = e.target.closest('[data-pf-qty]');
    if (qb) {
      e.preventDefault();
      e.stopPropagation();
      var inp = qb.parentElement.querySelector('input[name="quantity"]');
      if (inp) {
        var v = (parseInt(inp.value, 10) || 1) + parseInt(qb.getAttribute('data-pf-qty'), 10);
        inp.value = Math.max(1, v);
      }
      if (typeof window.__pfQtyRefresh === 'function') window.__pfQtyRefresh();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('.pf-add-form') : null;
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    doAdd(form);
  }, true);

  /* ---------- PDP: variantes + cantidad + galería ---------- */
  function setupPDP() {
    var root = document.querySelector('[data-pf-product]');
    if (!root) return;

    // precio total en el botón (precio de variante × cantidad)
    var form = root.querySelector('.pf-add-form');
    var unitPrice = form ? parseInt(form.getAttribute('data-pf-price'), 10) || 0 : 0;
    function updateAtcTotal() {
      var inp = root.querySelector('.pdp__qty input[name="quantity"]');
      var qty = Math.max(1, parseInt(inp && inp.value, 10) || 1);
      var total = pesos(unitPrice * qty / 100);
      var ap = root.querySelector('[data-pf-atc-price]');
      if (ap) ap.textContent = total;
      var sp = root.querySelector('[data-pf-sticky-price]');
      if (sp) sp.textContent = total;
    }
    window.__pfSetUnitPrice = function (cents) { unitPrice = cents; updateAtcTotal(); };
    window.__pfQtyRefresh = updateAtcTotal;
    updateAtcTotal();

    // cantidad
    root.querySelectorAll('[data-pf-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentElement.querySelector('input[name="quantity"]');
        if (!inp) return;
        var v = (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-pf-qty'), 10);
        inp.value = Math.max(1, v);
        updateAtcTotal();
      });
    });
    root.querySelectorAll('.pdp__qty input[name="quantity"]').forEach(function (inp) {
      inp.addEventListener('change', updateAtcTotal);
    });

    // galería deslizable: swipe nativo (scroll-snap) + flechas + drag con mouse + thumbs sincronizadas
    var track = root.querySelector('[data-pf-track]');
    var galGoTo = null;
    if (track) {
      var thumbs = root.querySelectorAll('[data-pf-thumb-i]');
      function slideW() { return track.clientWidth || 1; }
      function activeIndex() { return Math.round(track.scrollLeft / slideW()); }
      function goTo(i) {
        var target = i * slideW();
        var start = track.scrollLeft;
        track.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () {
          if (track.scrollLeft === start && start !== target) track.scrollLeft = target;
        }, 350);
      }
      galGoTo = goTo;
      function paintThumbs() {
        var i = activeIndex();
        thumbs.forEach(function (t) { t.classList.toggle('on', parseInt(t.getAttribute('data-pf-thumb-i'), 10) === i); });
      }
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paintThumbs); }, { passive: true });
      root.querySelectorAll('[data-pf-gal]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var n = track.querySelectorAll('.pdp__slide').length;
          var next = activeIndex() + parseInt(b.getAttribute('data-pf-gal'), 10);
          goTo(Math.max(0, Math.min(n - 1, next)));
        });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-pf-thumb-i'), 10)); });
      });
      // drag con mouse en desktop (touch usa el scroll nativo)
      var dragStartX = 0, dragStartLeft = 0, dragging = false, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = 0;
        dragStartX = e.clientX; dragStartLeft = track.scrollLeft;
        track.classList.add('dragging');
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        moved = Math.max(moved, Math.abs(dx));
        track.scrollLeft = dragStartLeft - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        goTo(Math.max(0, Math.min(track.querySelectorAll('.pdp__slide').length - 1, Math.round(track.scrollLeft / slideW()))));
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    // variantes (pastillas y/o selects)
    var dataEl = root.querySelector('[data-pf-variants]');
    var groups = root.querySelectorAll('[data-pf-option-group]');
    if (!dataEl || !groups.length) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function optValues() {
      var vals = [];
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-pf-option-group'), 10) - 1;
        var sel = g.querySelector('.pf-variant-select');
        if (sel) { vals[idx] = sel.value; return; }
        var on = g.querySelector('.pdp__pill.on');
        vals[idx] = on ? on.getAttribute('data-pf-opt-value') : null;
      });
      return vals;
    }

    function onChange() {
      var opts = optValues();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
      });
      var idInput = document.getElementById('pfVariantId');
      var price = document.getElementById('pfPrice');
      var atc = document.getElementById('pfAtc');
      var sticky = root.querySelector('[data-pf-sticky-price]');
      var stickyBtns = root.querySelectorAll('.pdp__sticky [data-pf-add]');
      if (match) {
        if (idInput) idInput.value = match.id;
        var m = pesos(match.price / 100);
        if (price) price.textContent = m;
        if (typeof window.__pfSetUnitPrice === 'function') window.__pfSetUnitPrice(match.price);
        // badges de dieta dependientes de variante (ej. Con/Sin lácteos)
        root.querySelectorAll('[data-pf-dyn-diet]').forEach(function (bdg) {
          var want = (bdg.getAttribute('data-pf-dyn-diet') || '').toLowerCase();
          var vals = [match.option1, match.option2, match.option3];
          bdg.hidden = !vals.some(function (o) { return o && o.toLowerCase() === want; });
        });
        // galería: saltar a la imagen de la variante seleccionada
        var fimg = match.featured_image || match.featured_media;
        if (galGoTo && fimg && fimg.position) {
          galGoTo(fimg.position - 1);
        }
        var ok = match.available;
        if (atc) {
          atc.disabled = !ok;
          var lbl = atc.querySelector('[data-pf-atc-label]');
          if (lbl) lbl.textContent = ok ? (atc.getAttribute('data-label') || 'Agregar al carrito') : 'Agotado';
        }
        stickyBtns.forEach(function (b) { b.disabled = !ok; });
      } else {
        if (atc) {
          atc.disabled = true;
          var lbl2 = atc.querySelector('[data-pf-atc-label]');
          if (lbl2) lbl2.textContent = 'No disponible';
        }
        stickyBtns.forEach(function (b) { b.disabled = true; });
      }
    }
    root.querySelectorAll('.pf-variant-select').forEach(function (s) { s.addEventListener('change', onChange); });
    window.__pfVariantRefresh = onChange;   // lo invoca el capturador global de pastillas
    var atcInit = document.getElementById('pfAtc');
    if (atcInit && !atcInit.disabled) {
      var lblInit = atcInit.querySelector('[data-pf-atc-label]');
      atcInit.setAttribute('data-label', (lblInit ? lblInit.textContent : atcInit.textContent).trim());
    }
  }

  /* ---------- Carrito: cambiar cantidades / quitar en vivo ---------- */
  function setupCartPage() {
    var root = document.querySelector('[data-pf-cart]');
    if (!root) return;
    var thr = (window.PF_FREESHIP && parseInt(window.PF_FREESHIP, 10)) || THRESHOLD;

    function paint(cart) {
      // líneas: actualizar totales o quitar filas
      root.querySelectorAll('.cline').forEach(function (row) {
        var key = row.getAttribute('data-pf-key');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) { row.remove(); return; }
        var inp = row.querySelector('[data-pf-line-input]');
        if (inp) inp.value = item.quantity;
        var tot = row.querySelector('[data-pf-line-total]');
        if (tot) tot.textContent = pesos(item.final_line_price / 100);
        row.classList.remove('is-busy');
      });
      var sub = root.querySelector('[data-pf-cart-subtotal]');
      if (sub) sub.textContent = pesos(cart.total_price / 100);
      var count = root.querySelector('.cartpg__count');
      if (count) count.textContent = '(' + cart.item_count + ')';
      // progreso de envío en el resumen
      var ship = root.querySelector('[data-pf-cart-ship]');
      if (ship) {
        var remaining = Math.max(0, thr - cart.total_price / 100);
        var fill = ship.querySelector('.ship-fill');
        if (fill) fill.style.width = Math.min(100, (cart.total_price / 100 / thr) * 100) + '%';
        var span = ship.querySelector('span');
        ship.classList.toggle('is-free', remaining <= 0);
        if (span) span.innerHTML = remaining > 0
          ? 'Te faltan <b>' + pesos(remaining) + '</b> para envío gratis'
          : '<b>¡Tienes envío gratis!</b> 🎉';
      }
      var ptsBox = root.querySelector('[data-pf-cart-points]');
      if (ptsBox) {
        var prate = parseFloat(ptsBox.getAttribute('data-ptsrate')) || 1;
        var pval = ptsBox.querySelector('[data-pf-cart-ptsval]');
        if (pval) pval.textContent = Math.floor((cart.total_price / 100) * prate);
      }
      var minEl = root.querySelector('[data-pf-cart-minorder]');
      if (minEl) {
        var minThr = (parseInt(minEl.getAttribute('data-min'), 10) || 300) * 100;
        var below = cart.total_price < minThr;
        minEl.hidden = !below;
        if (below) {
          var mr = minEl.querySelector('[data-pf-cart-minremain]');
          if (mr) mr.textContent = pesos((minThr - cart.total_price) / 100);
        }
      }
      refresh(); // barra del header + contador
      if (cart.item_count === 0) window.location.reload(); // estado vacío server-side
    }

    function change(row, qty) {
      row.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: row.getAttribute('data-pf-key'), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(paint)
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-pf-line-qty]');
      if (minus) {
        var row = minus.closest('.cline');
        var inp = row.querySelector('[data-pf-line-input]');
        var q = Math.max(0, (parseInt(inp.value, 10) || 1) + parseInt(minus.getAttribute('data-pf-line-qty'), 10));
        change(row, q);
        return;
      }
      var rm = e.target.closest('[data-pf-line-remove]');
      if (rm) change(rm.closest('.cline'), 0);
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-pf-line-input]');
      if (inp) change(inp.closest('.cline'), Math.max(0, parseInt(inp.value, 10) || 0));
    });
    // guardar nota al salir del campo
    var note = root.querySelector('textarea[name="note"]');
    if (note) note.addEventListener('blur', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    });
  }

  /* ---------- PLP: orden ---------- */
  function setupPLP() {
    var sel = document.querySelector('[data-pf-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init() { refresh(); setupHeader(); setupHero(); setupPDP(); setupPLP(); setupCartPage(); }
  window.addEventListener('load', function () { if (!heroTimer) setupHero(); });
  document.addEventListener('shopify:section:load', function () { setupHero(); });
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
